<div
  *ngIf="visible"
  class="fixed inset-0 z-50 overflow-y-auto"
  (click)="onClose()"
>
  <div class="flex items-center justify-center min-h-screen px-4 py-4">
    <div
      class="bg-white dark:bg-gray-800 rounded-2xl shadow-xl w-full max-w-md border border-gray-200 dark:border-gray-700 animate-scale-in"
      (click)="$event.stopPropagation()"
    >
      <div class="p-6">
        <div class="flex items-center justify-between mb-6">
          <h2 class="text-2xl font-bold text-gray-900 dark:text-white">Print / Download</h2>
          <button
            type="button"
            (click)="onClose()"
            class="p-2 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
            aria-label="Close"
          >
            <svg class="w-6 h-6 text-gray-500 dark:text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        <div class="space-y-3">
          <p *ngIf="!hasPrintOptions" class="text-sm text-gray-500 dark:text-gray-400 text-center py-4">
            All print formats are disabled. Enable them in Printer Settings.
          </p>

          <div *ngIf="thermalEnabled">
            <p class="text-sm font-semibold text-gray-700 dark:text-gray-300 mb-2">Thermal Printer</p>
            <div class="grid grid-cols-2 gap-3">
              <button type="button" (click)="onPrint('2inch')" class="bill-print-option">
                <svg class="w-8 h-8 mx-auto mb-2 text-primary-600 dark:text-primary-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 17h2a2 2 0 002-2v-4a2 2 0 00-2-2H5a2 2 0 00-2 2v4a2 2 0 002 2h2m2 4h6a2 2 0 002-2v-4a2 2 0 00-2-2H9a2 2 0 00-2 2v4a2 2 0 002 2zm8-12V5a2 2 0 00-2-2H9a2 2 0 00-2 2v4h10z" />
                </svg>
                <p class="font-semibold text-gray-900 dark:text-white">2 inch</p>
                <p class="text-xs text-gray-500 dark:text-gray-400">Thermal</p>
              </button>
              <button type="button" (click)="onPrint('3inch')" class="bill-print-option">
                <svg class="w-8 h-8 mx-auto mb-2 text-primary-600 dark:text-primary-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 17h2a2 2 0 002-2v-4a2 2 0 00-2-2H5a2 2 0 00-2 2v4a2 2 0 002 2h2m2 4h6a2 2 0 002-2v-4a2 2 0 00-2-2H9a2 2 0 00-2 2v4a2 2 0 002 2zm8-12V5a2 2 0 00-2-2H9a2 2 0 00-2 2v4h10z" />
                </svg>
                <p class="font-semibold text-gray-900 dark:text-white">3 inch</p>
                <p class="text-xs text-gray-500 dark:text-gray-400">Thermal</p>
              </button>
            </div>
          </div>

          <div *ngIf="a4Enabled">
            <p class="text-sm font-semibold text-gray-700 dark:text-gray-300 mb-2">A4 Printer</p>
            <div class="grid grid-cols-1 gap-3">
              <button *ngIf="isGstBill" type="button" (click)="onPrint('a4-gst')" class="bill-print-option bill-print-option--gst">
                <svg class="w-8 h-8 mx-auto mb-2 text-primary-600 dark:text-primary-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                </svg>
                <p class="font-semibold text-gray-900 dark:text-white">A4 GST</p>
                <p class="text-xs text-gray-500 dark:text-gray-400">Tax Invoice</p>
              </button>
              <button *ngIf="isEstimate" type="button" (click)="onPrint('a4-non-gst')" class="bill-print-option bill-print-option--estimate">
                <svg class="w-8 h-8 mx-auto mb-2 text-blue-600 dark:text-blue-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                </svg>
                <p class="font-semibold text-gray-900 dark:text-white">A4 Non-GST</p>
                <p class="text-xs text-gray-500 dark:text-gray-400">Estimate</p>
              </button>
            </div>
          </div>

          <div *ngIf="a5Enabled">
            <p class="text-sm font-semibold text-gray-700 dark:text-gray-300 mb-2">A5 Printer</p>
            <div class="grid grid-cols-1 gap-3">
              <button *ngIf="isGstBill" type="button" (click)="onPrint('a5-gst')" class="bill-print-option bill-print-option--gst">
                <svg class="w-8 h-8 mx-auto mb-2 text-primary-600 dark:text-primary-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                </svg>
                <p class="font-semibold text-gray-900 dark:text-white">A5 GST</p>
                <p class="text-xs text-gray-500 dark:text-gray-400">Tax Invoice</p>
              </button>
              <button *ngIf="isEstimate" type="button" (click)="onPrint('a5-non-gst')" class="bill-print-option bill-print-option--estimate">
                <svg class="w-8 h-8 mx-auto mb-2 text-blue-600 dark:text-blue-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                </svg>
                <p class="font-semibold text-gray-900 dark:text-white">A5 Non-GST</p>
                <p class="text-xs text-gray-500 dark:text-gray-400">Estimate</p>
              </button>
            </div>
          </div>

          <div *ngIf="a4Enabled">
            <p class="text-sm font-semibold text-gray-700 dark:text-gray-300 mb-2">A4 PDF Download</p>
            <div class="grid grid-cols-1 gap-3">
              <button *ngIf="isGstBill" type="button" [disabled]="isDownloading" (click)="onPdf('a4')" class="bill-print-option bill-print-option--gst">
                <svg class="w-8 h-8 mx-auto mb-2 text-primary-600 dark:text-primary-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                </svg>
                <p class="font-semibold text-gray-900 dark:text-white">Download A4 GST PDF</p>
              </button>
              <button *ngIf="isEstimate" type="button" [disabled]="isDownloading" (click)="onPdf('a4')" class="bill-print-option bill-print-option--estimate">
                <svg class="w-8 h-8 mx-auto mb-2 text-blue-600 dark:text-blue-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                </svg>
                <p class="font-semibold text-gray-900 dark:text-white">Download A4 Non-GST PDF</p>
              </button>
            </div>
          </div>

          <div *ngIf="a5Enabled">
            <p class="text-sm font-semibold text-gray-700 dark:text-gray-300 mb-2">A5 PDF Download</p>
            <div class="grid grid-cols-1 gap-3">
              <button *ngIf="isGstBill" type="button" [disabled]="isDownloading" (click)="onPdf('a5')" class="bill-print-option bill-print-option--gst">
                <svg class="w-8 h-8 mx-auto mb-2 text-primary-600 dark:text-primary-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                </svg>
                <p class="font-semibold text-gray-900 dark:text-white">Download A5 GST PDF</p>
              </button>
              <button *ngIf="isEstimate" type="button" [disabled]="isDownloading" (click)="onPdf('a5')" class="bill-print-option bill-print-option--estimate">
                <svg class="w-8 h-8 mx-auto mb-2 text-blue-600 dark:text-blue-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                </svg>
                <p class="font-semibold text-gray-900 dark:text-white">Download A5 Non-GST PDF</p>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
